import styled from 'styled-components';

export const AppName = styled.span`
  font-size: 19px;

  span {
    font-weight: 700;
  }
`;
